// extracted by mini-css-extract-plugin
export default {"wrapper":"MultiContainer_wrapper__CQi-l","linksContainer":"MultiContainer_linksContainer__OZb1X","link":"MultiContainer_link__NMBaR","mainTitle":"MultiContainer_mainTitle__oHMol"};